export const CARDS_TOTALS_BY_ACCOUNT_PATH = '/account/:accountNumber/cards/totals';
export const CARDS_TOTALS_PATH = '/card/:cardNumber/totals';
export const CARDS_AUTHORIZATIONS_PATH = '/card/:cardNumber/authorizations';
export const SEARCH_CARD_TOTALS_PATH = '/card/totals/search';
export const SEARCH_CARD_AUTHORIZATIONS_PATH = '/card/authorizations/search';
export const SEARCH_CARD_TOTALS_BY_PERIOD_PATH = '/card/totals/searchByPeriod';
export const LIST_CARDS_PATH = '/cards';
export const CARD_ASSOCIATE_TO_COSTCENTER= '/card/associateCard';
export const ASSOCIATE_CARD_PATH = '/card/associateCard';